import { ComponentPropsWithoutRef } from 'react'

import { Card } from '../Card'
import { Carousel } from '../Carousel'

type CardProps = ComponentPropsWithoutRef<typeof Card> & {
	anchorLink?: string
}

type Props = {
	cards: Omit<CardProps, 'className'>[]
	className?: string
	dataTestId?: string
	bgColor?: string
	variant?: 'light' | 'dark'
	autoplay?: number
	itemsShown?: number
	skip: number
	loop?: boolean
}

export function CardCarousel({
	cards,
	className,
	bgColor,
	variant = 'light',
	autoplay,
	dataTestId,
	itemsShown = 4,
	skip,
	loop
}: Props) {
	return (
		<Carousel
			dataTestId={dataTestId}
			className={className}
			autoplay={autoplay}
			itemsShown={itemsShown}
			skip={skip}
			loop={loop}
		>
			{cards.map((card, index) => (
				<Card key={index} {...card} variant={variant} bgColor={bgColor} />
			))}
		</Carousel>
	)
}
